import $ from 'jquery';

/**
 * Initialize accordions for event program section
 */
export default () => {
  document.querySelectorAll('.program__timeslot-toggle').forEach((el) => {
    el.addEventListener('click', () => {
      const $body = $(el).siblings().first();
      const $parent = $(el).parent();

      $body.slideToggle();
      $parent.toggleClass('program__timeslot--open');
    });
  });
};
